export default __webpack_public_path__ + "f168603ca441f926d9a20f13ea510b19.svg";